export const UPDATE_CONTROL_DELAY = 1000

export const OBJECTIVE_WARNING =
  'Caution: Editing the objective changes this control materially. Policy, procedure, and evidence may need to change.'

export const GUIDANCE_WARNING =
  'Great care should be taken when editing. The Trustero Customer Success and GRC teams are happy to help with this process.'

/**
 * Stable keys for control show page tabs. Each is also its `?showTab=` value, and
 * they match the old `?defaultTab=` values so links already sent keep working.
 */
export enum ControlShowTabKey {
  OVERVIEW = 'overview',
  REQUESTS = 'requests',
  EVIDENCE = 'evidence',
  EVIDENCE_SUGGESTIONS = 'evidence-suggestions',
  AUDIT_SCANS = 'audit-scans',
  RISKS = 'risks',
  GUIDANCE = 'guidance',
  NOTES = 'notes',
}
